
// Internal dependencies
import SDTMath from './sdt-math';

export default SDTMath;
